module.exports = __webpack_public_path__ + "img/27.69ca6291.png";